import React from "react";
import CapacitorSafeAddressInput from "./CapacitorSafeAddressInput";

/**
 * Wrapper that delegates to CapacitorSafeAddressInput (Google Maps Places API).
 * Keeps the same props interface for select_glocery, select_address_native, address-dialog-form.
 */
const SafeGooglePlacesAutocomplete = (props) => (
  <CapacitorSafeAddressInput {...props} />
);

export default SafeGooglePlacesAutocomplete;
